import "core-js/modules/es.array.push.js";
import { computed, defineComponent, onBeforeMount, ref, watch } from 'vue';
import { mapState, mapGetters } from 'vuex';
import { PluginPlatforms } from '@remote/constant';
import { IconTvCinemaNew } from '@xunlei/thunder-icon-vue';
import { getLocalValue, setLocalValue } from '@remote/utils/index';
import { useDeviceStore } from '@remote/store/device';
export default defineComponent({
  components: {
    IconTvCinemaNew
  },
  setup() {
    const isCinemaShowRef = ref(false);
    const isPluginShowRef = ref(false);
    const deviceStore = useDeviceStore();
    const isServerSupportPlugin = computed(() => {
      var _deviceStore$currentD;
      return (_deviceStore$currentD = deviceStore.currentDeviceRef) === null || _deviceStore$currentD === void 0 ? void 0 : _deviceStore$currentD.util.hasLabel('withPlugin');
    });
    const baseConfig = computed(() => {
      var _deviceStore$currentD2;
      return (_deviceStore$currentD2 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD2 === void 0 ? void 0 : _deviceStore$currentD2.baseConfigRef;
    });
    const configIsCinemaDisabled = computed(() => {
      var _baseConfig$value;
      return (_baseConfig$value = baseConfig.value) === null || _baseConfig$value === void 0 || (_baseConfig$value = _baseConfig$value.nfo_config) === null || _baseConfig$value === void 0 ? void 0 : _baseConfig$value.is_disabled;
    });
    const configIsPluginShow = computed(() => {
      var _deviceStore$currentD3, _deviceStore$currentD4;
      return Boolean(PluginPlatforms.includes((_deviceStore$currentD3 = (_deviceStore$currentD4 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD4 === void 0 || (_deviceStore$currentD4 = _deviceStore$currentD4.runnerTaskRef) === null || _deviceStore$currentD4 === void 0 || (_deviceStore$currentD4 = _deviceStore$currentD4.params) === null || _deviceStore$currentD4 === void 0 ? void 0 : _deviceStore$currentD4.platform) !== null && _deviceStore$currentD3 !== void 0 ? _deviceStore$currentD3 : '') && isServerSupportPlugin.value);
    });
    onBeforeMount(() => {
      // 读取缓存
      if (localStorage.getItem('isCinemaShow') === 'true') {
        // 个人影院展示缓存
        isCinemaShowRef.value = true;
      }
      if (localStorage.getItem('isPluginShow') === 'true') {
        // 小工具展示缓存
        isPluginShowRef.value = true;
      }
    });
    watch(configIsCinemaDisabled, val => {
      if (val === undefined) return;
      isCinemaShowRef.value = !val;
      console.log('2- isCinemaShowRef.value', val, isCinemaShowRef.value);
      // 更新缓存
      localStorage.setItem('isCinemaShow', String(isCinemaShowRef.value));
    }, {
      immediate: true
    });
    watch(configIsPluginShow, val => {
      isPluginShowRef.value = val;
      // 更新缓存
      localStorage.setItem('isPluginShow', String(isPluginShowRef.value));
    }, {
      immediate: true
    });
    return {
      isCinemaShowRef,
      isPluginShowRef,
      configIsCinemaShow: configIsCinemaDisabled,
      configIsPluginShow
    };
  },
  data() {
    return {
      currentPage: '',
      showPoint: this.isNative && !getLocalValue('hideMePoint')
    };
  },
  computed: {
    ...mapState(['isSelect', 'isNative', 'status', 'curDeviceRunner', 'deviceInfoWatchData']),
    ...mapGetters(['downloadAndPendingList']),
    show() {
      return ['home', 'me', 'plugin', 'cinema'].includes(this.$route.name) && !this.isSelect;
    },
    num() {
      const total = this.downloadAndPendingList.length > 0 ? this.downloadAndPendingList.length : '';
      return total > 20 ? '20+' : total;
    },
    clientVersion() {
      var _this$deviceInfoWatch, _this$deviceInfoWatch2;
      return (_this$deviceInfoWatch = (_this$deviceInfoWatch2 = this.deviceInfoWatchData) === null || _this$deviceInfoWatch2 === void 0 ? void 0 : _this$deviceInfoWatch2.client_version) !== null && _this$deviceInfoWatch !== void 0 ? _this$deviceInfoWatch : '';
    }
  },
  watch: {
    '$route.name': {
      handler(val) {
        if (this.show) {
          this.currentPage = val;
        }
      },
      immediate: true
    }
  },
  methods: {
    selectPage(page) {
      if (this.showPoint) {
        setLocalValue('hideMePoint', true);
        this.showPoint = false;
      }
      this.$router.push({
        name: page,
        query: this.$route.query
      });
    }
  }
});